import React from "react"
import Google from "../images/Google-Haritalar.svg"
import styled from "styled-components"
import Fade from "react-reveal/Fade"

const GoogleWrapper = styled.div`
  position: fixed;
  width: 60px;
  height: 80px;
  bottom: 0;
  text-align: center;
  right: 15px;
  z-index: 100;
  .my-float {
    margin-top: 10px;
  }
  @media screen and (max-width: ${props => props.theme.sizes.mobile}) {
    display: none;
  }
`

const GoogleLink = () => (
  <GoogleWrapper>
    <Fade bottom cascade>
      <a
        href="https://goo.gl/maps/9ShdMsKeoChbxvPt6"
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          title="Ayazsan Google Harita"
          src={Google}
          alt="Ayazsan Google Harita"
        />
      </a>
    </Fade>
  </GoogleWrapper>
)

export default GoogleLink
